import { Selectable, ShallowDehydrateObject } from 'kysely'
import { UserDevices, Users } from '../db.js'
import { UserSettingsResponse } from './UsersSettings.js'

export type DUserDeviceEntity = Pick<Selectable<UserDevices>, 'deviceId' | 'lastSeen' | 'createdAt' | 'details'>

export type UserDeviceEntity = ShallowDehydrateObject<DUserDeviceEntity>

export type DUserEntity = Omit<Selectable<Users>, 'disabled'> & {
    disabled: boolean
    lastActive: Date | null
    customerName: string | null
    deviceCount: number
}

export type UserEntity = ShallowDehydrateObject<DUserEntity>

export type DUserListItem = Pick<Selectable<Users>, 'id' | 'email' | 'name' | 'userCategory' | 'customerId'> & {
    disabled: boolean
    lastActive: Date | null
    customerName: string | null
    deviceCount: number
}

export type UserListItem = ShallowDehydrateObject<DUserListItem>

export type DUserAdminDetail = DUserEntity & {
    devices: DUserDeviceEntity[]
}

export type UserAdminDetail = UserEntity & {
    devices: UserDeviceEntity[]
}

export const USER_MULTI_DEVICE_THRESHOLD = 2

export function userHasManyDevices(deviceCount: number): boolean {
    return deviceCount > USER_MULTI_DEVICE_THRESHOLD
}

export type UserMe = Omit<Selectable<Users>, 'settings'> & { settings: UserSettingsResponse }
